const APP_TUTORIAL_STEPS = {
    Video : "Video",
    Assessment : "Assessment"
}

const HEADER_TITLES = {
  Video: 'Video Tutorial',
  Assessment: 'Assessment'
};

const ERROR_MESSAGES = {
  FETCH_ERROR: 'Error fetching tutorial data',
  DATA_UNAVAILABLE: 'Tutorial data unavailable'
};

export { APP_TUTORIAL_STEPS, HEADER_TITLES, ERROR_MESSAGES };